module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/11-bcd9d878d24980c9d8cc36151abb6c93.png";